import { LOGO_URL, LOGO_DARK_FILTER } from "@/lib/brand";

export default function Logo({ size = 36, withText = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="relative overflow-hidden rounded-md"
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO_URL}
          alt="Mo's Glanzwerk Logo"
          style={{
            width: size * 2.6,
            height: size * 2.6,
            objectFit: "cover",
            objectPosition: "center 38%",
            filter: LOGO_DARK_FILTER,
            mixBlendMode: "screen",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
      {withText && (
        <div className="leading-tight">
          <div className="font-heading text-base tracking-tight">
            Mo's <span className="text-gradient-gold">Glanzwerk</span>
          </div>
          <div className="text-[9px] uppercase tracking-[0.25em] text-zinc-500 -mt-0.5">
            MGW-Dienstleistung
          </div>
        </div>
      )}
    </div>
  );
}
